import AliadaAnalytics from './analytics'
export default AliadaAnalytics



// WEBPACK FOOTER //
// ./src/services/aliada-analytics/index.js